import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import App from './components/App';
import NavDrawer from './components/auth/NavDrawer';
import Home from './components/home/Home';
import Welcome from './components/home/Welcome';
import MagicLinkHome from './components/home/MagicLinkHome';
import Verify from './components/home/Verify';
import OAuth2Redirect from './components/auth/OAuth2Redirect';
import PlaidOAuth2Redirect from './components/auth/PlaidOAuth2Redirect';
import OidcRedirect from './components/auth/OidcRedirect';
import Signup from './components/home/Signup';
import Register from './components/home/Register';
import Login from './components/home/Login';
import PasswordChange from './components/home/PasswordChange';
import Notification from './components/notification/Notification';
import Catalog from './components/app/Catalog';
import AppSummary from './components/app/AppSummary';
import AppSummaryTable from './components/app/AppSummaryTable';
import AppCreate from './components/app/AppCreate';
import AppEdit from './components/app/AppEdit';
import ServiceCreate from './components/app/ServiceCreate';
import ServiceEdit from './components/app/ServiceEdit';
import CommunicationTemplateList from './components/account/CommunicationTemplateList';
import CommunicationTemplate from './components/account/CommunicationTemplate';
import CustomerAppList from './components/app/CustomerAppList';
import CustomerTasks from './components/tasks/CustomerTasks';
import MyCharges from './components/app/MyCharges';
import MyStatements from './components/app/MyStatements';
import FundingSources from './components/paymentsources/FundingSources';
import Settings from './components/settings/Settings';
import IntegrationSetupXero from './components/settings/IntegrationSetupXero';
import IntegrationSetupQBO from './components/settings/IntegrationSetupQBO';
import IntegrationSetupFreshbooks from './components/settings/IntegrationSetupFreshbooks';
import IntegrationSetupRecurly from './components/settings/IntegrationSetupRecurly';
import IntegrationSetupCustomApi from './components/settings/IntegrationSetupCustomApi';
import Accounts from './components/account/Accounts';
import AdminAppSummary from './components/account/AdminAppSummary';
import AdminResellerReport from './components/account/AdminResellerReport';
import BindCards from './components/account/BindCards';
import BindCardSummary from './components/account/BindCardSummary';
import BusinessBeneficialOwnerCreate from './components/kyb/BusinessBeneficialOwnerCreate';
import BusinessBeneficialOwnerEdit from './components/kyb/BusinessBeneficialOwnerEdit';
import BusinessIdentityCreate from './components/kyb/BusinessIdentityCreate';
import BusinessIdentityEdit from './components/kyb/BusinessIdentityEdit';
import DocumentUpload from './components/kyb/DocumentUpload';
import DocumentViewer from './components/kyb/DocumentViewer';
import CustomerSearch from './components/account/CustomerSearch';
import Customer from './components/account/Customer';
import CustomerImport from './components/account/CustomerImport';
import CustomerCreate from './components/account/CustomerCreate';
import UserCreate from './components/account/UserCreate';
import UserEdit from './components/account/UserEdit';
import AccountLedgers from './components/account/AccountLedgers';
import LandingPages from './components/landing/LandingPages';
import LandingPageCreate from './components/landing/LandingPageCreate';
import LandingPageEdit from './components/landing/LandingPageEdit';
import LandingPageCreateOld from './components/landing/LandingPageCreateOld';
import LandingPageEditOld from './components/landing/LandingPageEditOld';
import Ledger from './components/account/Ledger';
import Payout from './components/vendor/Payout';
import CreatePayouts from './components/account/CreatePayouts';
// import ProgramSettings from './components/vendor/ProgramSettings';
import ProgramSettingsAdmin from './components/vendor/ProgramSettingsAdmin';
import PayoutDetail from './components/vendor/PayoutDetail';
import PayoutDetailInstant from './components/vendor/PayoutDetailInstant';
import ProfitabilityReport from './components/account/ProfitabilityReport';
import VendorPartnerProgram from './components/vendor/VendorPartnerProgram';
import VendorCommProgramCreate from './components/vendor/VendorCommProgramCreate';
import VendorCommProgramEdit from './components/vendor/VendorCommProgramEdit';
import ResellerProgramEdit from './components/vendor/ResellerProgramEdit';
import ResellerCommProgramView from './components/vendor/ResellerCommProgramView';
import Transaction from './components/account/Transaction';
import Transactions from './components/account/Transactions';
import BindCardTransactions from './components/account/BindCardTransactions';
import ServiceTransactions from './components/account/ServiceTransactions';
import SubscriptionCreate from './components/customer/SubscriptionCreate';
import SubscriptionCreateForSelf from './components/customer/SubscriptionCreateForSelf';
import SubscriptionManage from './components/account/SubscriptionManage';
import SubscriptionView from './components/account/SubscriptionView';
import ServiceManage from './components/account/ServiceManage';
import TransferAssent from './components/customer/TransferAssent';
import Vendor from './components/account/Vendor';
import VendorCreate from './components/account/VendorCreate';
import VendorReseller from './components/vendor/VendorReseller';
import Reseller from './components/account/Reseller';
import ResellerCreate from './components/account/ResellerCreate';
import Invoice from './components/account/Invoice';
import ResellerInvoiceSummary from './components/account/ResellerInvoiceSummary';
import ResellerDocuments from './components/account/ResellerDocuments';
import ResellerVendor from './components/vendor/ResellerVendor';
import VendorCommProgramSearch from './components/vendor/VendorCommProgramSearch';
import Help from './components/help/Help';
import Callback from './components/callback/Callback';
import Auth from './components/auth/Auth';
import Partner from './components/landing/Partner';
import PartnerHome from './components/suborderlanding/PartnerHome';
import StepSignInUp from './components/suborderlanding/StepSignInUp';
import StepSignUpCheckEmail from './components/suborderlanding/StepSignUpCheckEmail';
import StepperAuthorize from './components/custauthorization/StepperAuthorize';
import SubscriptionOrderLandingCreate from './components/landing/SubscriptionOrderLandingCreate';
import SubscriptionOrderLandingEdit from './components/landing/SubscriptionOrderLandingEdit';
import TemplateAppSearch from './components/account/TemplateAppSearch';
import TemplateAppEdit from './components/account/TemplateAppEdit';
import FeatureFlagManage from './components/account/FeatureFlagManage';

import SubscriptionOrder from './components/suborder/SubscriptionOrder';
import SubscriptionOrderLoad from './components/suborder/SubscriptionOrderLoad';
import SubscriptionOrderView from './components/customer/SubscriptionOrderView';
import SubscriptionOrderApprove from './components/custauthorization/SubscriptionOrderApprove'

import Projects from './components/customer/Projects';

import VendorProgramForm from './components/forms/VendorProgramForm';
// import FormTester from './components/forms/FormTester';

import SystemDownAlert from './components/auth/SystemDownAlert';
import history from './history';
import classNames from 'classnames';
import FormEdit from './components/forms/FormEdit';

const auth = new Auth();

const openDrawerWidth = 196;
const narrowDrawerWidth = 50;

//SDW does not like computations below......see changes
const styleSheet = theme => ({
  root: {
  },
  fpcontent: {
    flexGrow: 1,
    marginTop: 20,
  },
  content: {
    flexGrow: 1,
    marginTop: theme.spacing(8),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  [theme.breakpoints.up('xs')]: {
    content: {
      //padding: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
      //padding: `24px 16px 16px 16px`,
      padding: `8px 8px 8px 8px`,
    },
    'content-left': {
      marginLeft: narrowDrawerWidth,
    },
    'contentShift-left': {
      marginLeft: openDrawerWidth
    },
  },
  [theme.breakpoints.up('sm')]: {
    content: {
      //padding: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
      padding: `24px 16px 16px 16px`,
    },
    'content-left': {
      //marginLeft: narrowDrawerWidth + theme.spacing(6),
      marginLeft: '74px',
      marginRight: theme.spacing(6)
    },
    'contentShift-left': {
      marginLeft: '256px',
      marginRight: theme.spacing(6)
    },
  },
  [theme.breakpoints.up('md')]: {
    content: {
      //padding: `${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
      padding: `24px 24px 24px 24px`,
    },
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
});


class MainRoute extends Component {

  state = { open: true };

  componentDidMount() {
    document.body.style.backgroundColor = "#f7f7f7";

    if (window.location.pathname.startsWith('/steppercustomerauthorize')  || window.location.pathname.startsWith('/order') || window.location.pathname.startsWith('/authonlyauthorize'))
    {
       this.setState({open: false});
    }
  }

  handleAuthentication = (nextState, replace) => {

    if (/access_token|id_token|error/.test(nextState.location.hash)) {
      // if the search parm is set, add to local storage
      let params = new URLSearchParams(nextState.location.search);
      let signupLoginApp = params.get("app");
      if (signupLoginApp != null) {
        localStorage.setItem('app_parm', signupLoginApp);
      }

      let signupVendorResellerId = params.get('vraid');
      if (signupVendorResellerId != null) {
        localStorage.setItem('vraid', signupVendorResellerId);
      }

      auth.handleAuthentication();
    } else {
      console.log(JSON.stringify(nextState));
    }
  }

  handleNavDrawerToggle = (drawerState) => {
    this.setState({ open: !this.navdrawer.state.open });
  }

  logout = () => {
    auth.logout();
  }

  render = (props) => {
    const classes = this.props.classes;

    let noLeftNav = false;

    // Ignore if on the partner route
    if (window.location.pathname.startsWith('/partner')) {
      noLeftNav = true;
    }
    // Ignore if on the order route
    if (window.location.pathname.startsWith('/order')) {
      noLeftNav = true;
    }
    //TODO consolidate these...
    if (window.location.pathname.startsWith('/steppersignin')) {
      noLeftNav = true;
    }
    if (window.location.pathname.startsWith('/steppersigninemail')) {
      noLeftNav = true;
    }
    if (window.location.pathname.startsWith('/verify')) {
      noLeftNav = true;
    }
    if (window.location.pathname.startsWith('callback')) {
      noLeftNav = true;
    }
    if (window.location.pathname.startsWith('/steppercustomerauthorize')) {
      noLeftNav = true;
    }
    if (window.location.pathname.startsWith('/authonlyauthorize'))
    {
      noLeftNav = true;
    }
    if (window.location.pathname.startsWith('/systemdown')) {
      noLeftNav = true;
    }

    // Update: as of #166, the unauthenticated customer now gets a left nav.
    //         left this code in case the decision to revert 
    // Unauthenticated customer does not get navigation or drawer.
    /*if (auth.isUnauthenticatedCustomer()) {
      this.state.open = false;
      noLeftNav = true;
    }*/

    /*
    ^(?!.*(/partner)).*$
    {new RegExp("^(?!.*(/partner)).*$")}
    "^(?!.*(/partner)).*$"
    {new RegExp("^(?!(/partner)).*$")}
    "(^/(?!(partner)).*$)"
    */
    
    /* classname setting based on left nav */
    let noLeftNavClasses = classNames(classes.content, 'content');
    let leftNavClasses = classNames(classes.content, 'content', classes[`content-left`], {[classes.contentShift]: this.state.open, [classes[`contentShift-left`]]: this.state.open});

    let theNavClasses = "";
    if (noLeftNav === true) {
      theNavClasses = noLeftNavClasses;
    } else {
      theNavClasses = leftNavClasses;
    }

    return (
      <Router history={history} component={App} routes={this}>
        <div id="Router" className="root">
          <Route path="/" render={(props) => <App auth={auth} routes={this} {...props} />} />
          {!noLeftNav &&
            <React.Fragment>
              <Route path="/" render={(props) => <NavDrawer auth={auth} history={this.props.history} narrow={true} onToggle={this.handleNavDrawerToggle}
                onRef={ref => (this.navdrawersmall = ref)} routes={this} {...props} />} />
              <Route path="/" render={(props) => <NavDrawer auth={auth} history={this.props.history} onToggle={this.handleNavDrawerToggle}
                onRef={ref => (this.navdrawer = ref)} routes={this} {...props} />} />
            </React.Fragment>
          }
          <main id="content" className={theNavClasses}>
            <Switch>
              {/* TODO: Change some routes to protected dependent on user role */}
              <Route exact={true} path="/" render={(props) => <Home auth={auth} {...props} />} />
              {/* <Route exact={true} path="/" render={(props) => <Login auth={auth} {...props} />} /> */}
              <Route path="/home" render={(props) => <Home auth={auth} {...props} />} />
              <Route path="/welcome" render={(props) => <Welcome auth={auth} {...props} />} />
              <Route path="/signup" render={(props) => <Signup auth={auth} {...props} />} />
              <Route path="/register" render={(props) => <Register auth={auth} {...props} />} />
              <Route path="/landingpages" render={(props) => <LandingPages auth={auth} {...props} />} />
              <Route path="/landingpagecreate" render={(props) => <LandingPageCreate auth={auth} {...props} />} />
              <Route path="/landingpageedit" render={(props) => <LandingPageEdit auth={auth} {...props} />} />
              <Route path="/landingpagecreateadmin" render={(props) => <LandingPageCreateOld auth={auth} {...props} />} />
              <Route path="/landingpageeditadmin" render={(props) => <LandingPageEditOld auth={auth} {...props} />} />
              <Route path="/login" render={(props) => <Login auth={auth} {...props} />} />
              <Route path="/passwordchange" render={(props) => <PasswordChange auth={auth} {...props} />} />
              <Route path="/notification" render={(props) => <Notification auth={auth} {...props} />} />
              <Route path="/help" render={(props) => <Help auth={auth} menuState={this.state.open} {...props} />} />
              <Route path="/customers" render={(props) => <CustomerSearch auth={auth} {...props} />} />
              <Route path="/catalog" render={(props) => <Catalog auth={auth} {...props} />} />
              <Route path="/apps" render={(props) => <AppSummary auth={auth} {...props} />} />
              <Route path="/appsgrid" render={(props) => <AppSummaryTable auth={auth} {...props} />} />
              <Route path="/app" render={(props) => <AppEdit auth={auth} appId='' {...props} />} />
              <Route path="/appcreate" render={(props) => <AppCreate auth={auth} {...props} />} />
              <Route path="/serviceedit" render={(props) => <ServiceEdit auth={auth} appId='' {...props} />} />
              <Route path="/servicecreate" render={(props) => <ServiceCreate auth={auth} {...props} />} />
              <Route path="/communicationtemplatelist" render={(props) => <CommunicationTemplateList auth={auth} {...props} />} />
              <Route path="/communicationtemplate" render={(props) => <CommunicationTemplate auth={auth} {...props} />} />
              <Route path="/mytasks" render={(props) => <CustomerTasks auth={auth} {...props} />} />
              <Route path="/myapps" render={(props) => <CustomerAppList auth={auth} {...props} />} />
              <Route path="/mycharges" render={(props) => <MyCharges auth={auth} {...props} />} />
              <Route path="/mystatements" render={(props) => <MyStatements auth={auth} {...props} />} />
              <Route path="/settings" render={(props) => <Settings auth={auth} {...props} />} />
              <Route path="/integrationxero" render={(props) => <IntegrationSetupXero auth={auth} adaId='' {...props} />} />
              <Route path="/integrationqbo" render={(props) => <IntegrationSetupQBO auth={auth} adaId='' {...props} />} />
              <Route path="/integrationfb" render={(props) => <IntegrationSetupFreshbooks auth={auth} adaId='' {...props} />} />
              <Route path="/integrationrecurly" render={(props) => <IntegrationSetupRecurly auth={auth} adaId='' {...props} />} />
              <Route path="/integrationapi" render={(props) => <IntegrationSetupCustomApi auth={auth} {...props} />} />
              <Route path="/fundingsources" render={(props) => <FundingSources auth={auth} {...props} />} />
              <Route path="/adminappsummary" render={(props) => <AdminAppSummary auth={auth} searchP='' {...props} />} />
              <Route path="/adminresellerreport" render={(props) => <AdminResellerReport auth={auth} {...props} />} />
              <Route path="/accounts" render={(props) => <Accounts auth={auth} searchP='' {...props} />} />
              <Route path="/accountledgers" render={(props) => <AccountLedgers auth={auth} accountId='' {...props} />} />
              <Route path="/ledger" render={(props) => <Ledger auth={auth} ledgerId='' {...props} />} />
              <Route path="/transaction" render={(props) => <Transaction auth={auth} transactionId='' {...props} />} />
              <Route path="/transactions" render={(props) => <Transactions auth={auth} transactionId='' {...props} />} />
              <Route path="/bctransactions" render={(props) => <BindCardTransactions auth={auth} {...props} />} />
              <Route path="/servicetransactions" render={(props) => <ServiceTransactions auth={auth} {...props} />} />
              <Route path="/createpayouts" render={(props) => <CreatePayouts auth={auth} {...props} />} />
              <Route path="/bindcards" render={(props) => <BindCards auth={auth} {...props} />} />
              <Route path="/bindcardsummary" render={(props) => <BindCardSummary auth={auth} {...props} />} />
              <Route path="/businessidentitycreate" render={(props) => <BusinessIdentityCreate auth={auth} {...props} />} />
              <Route path="/businessidentityedit" render={(props) => <BusinessIdentityEdit auth={auth} {...props} />} />
              <Route path="/businessbeneficialownercreate" render={(props) => <BusinessBeneficialOwnerCreate auth={auth} {...props} />} />
              <Route path="/businessbeneficialowneredit" render={(props) => <BusinessBeneficialOwnerEdit auth={auth} {...props} />} />
              <Route path="/documentupload" render={(props) => <DocumentUpload auth={auth} {...props} />} />
              <Route path="/documentviewer" render={(props) => <DocumentViewer auth={auth} {...props} />} />
              <Route path="/customer" render={(props) => <Customer auth={auth} accountId='' {...props} />} />
              <Route path="/usercreate" render={(props) => <UserCreate auth={auth} {...props} />} />
              <Route path="/useredit" render={(props) => <UserEdit auth={auth} {...props} />} />
              <Route path="/customercreate" render={(props) => <CustomerCreate auth={auth} {...props} />} />
              <Route path="/customerimport" render={(props) => <CustomerImport auth={auth} {...props} />} />
              <Route path="/subscriptioncreate" render={(props) => <SubscriptionCreate auth={auth} {...props} />} />
              <Route path="/subscriptioncreateself" render={(props) => <SubscriptionCreateForSelf auth={auth} {...props} />} />
              <Route path="/subscriptionorder" render={(props) => <SubscriptionOrder auth={auth} {...props} />} />
              <Route path="/subscriptionorderload" render={(props) => <SubscriptionOrderLoad auth={auth} {...props} />} />
              <Route path="/subscription" render={(props) => <SubscriptionManage customerAppId='' auth={auth} navopen={this.state.open} {...props} />} />
              <Route path="/subscriptionview" render={(props) => <SubscriptionView customerAppId='' auth={auth} {...props} />} />
              <Route path="/servicemanage" render={(props) => <ServiceManage customerAppId='' auth={auth} navopen={this.state.open} {...props} />} />
              <Route path="/solandingcreate" render={(props) => <SubscriptionOrderLandingCreate auth={auth} {...props} />} />
              <Route path="/solandingedit" render={(props) => <SubscriptionOrderLandingEdit auth={auth} {...props} />} />
              <Route path="/transferassent" render={(props) => <TransferAssent auth={auth} {...props} />} />
              <Route path="/vendorpartnerprogram" render={(props) => <VendorPartnerProgram auth={auth} {...props} />} />
              <Route path="/vendor" render={(props) => <Vendor auth={auth} accountId='' {...props} />} />
              <Route path="/vendorcreate" render={(props) => <VendorCreate auth={auth} {...props} />} />
              <Route path="/resellerprogramedit" render={(props) => <ResellerProgramEdit auth={auth} {...props} />} />
              <Route path="/resellercommprogramview" render={(props) => <ResellerCommProgramView auth={auth} {...props} />} />
              <Route path="/invoice" render={(props) => <Invoice auth={auth} invoiceId='' {...props} />} />
              <Route path="/invoicesummary" render={(props) => <ResellerInvoiceSummary auth={auth} {...props} />} />
              <Route path="/rdocuments" render={(props) => <ResellerDocuments auth={auth} {...props} />} />
              <Route path="/vendorreseller" render={(props) => <VendorReseller auth={auth} {...props} />} />
              <Route path="/reseller" render={(props) => <Reseller auth={auth} accountId='' {...props} />} />
              <Route path="/resellercreate" render={(props) => <ResellerCreate auth={auth} {...props} />} />
              <Route path="/resellervendor" render={(props) => <ResellerVendor auth={auth} {...props} />} />
              <Route path="/commprograms" render={(props) => <VendorCommProgramSearch auth={auth} {...props} />} />
              <Route path="/vendorcommprogramcreate" render={(props) => <VendorCommProgramCreate auth={auth} {...props} />} />
              <Route path="/vendorcommprogramedit" render={(props) => <VendorCommProgramEdit auth={auth} {...props} />} />
              <Route path="/templateappsearch" render={(props) => <TemplateAppSearch auth={auth} {...props} />} />
              <Route path="/templateappedit" render={(props) => <TemplateAppEdit auth={auth} {...props} />} />
              <Route path="/featureflagmanage" render={(props) => <FeatureFlagManage auth={auth} {...props} />} />

              <Route path="/formedit" render={(props) => <FormEdit accountId='' formId='' auth={auth} navopen={this.state.open} {...props} />} />
              <Route path="/programsettings" render={(props) => <ProgramSettingsAdmin auth={auth} {...props} />} />
              <Route path="/payout" render={(props) => <Payout auth={auth} {...props} />} />
              <Route path="/payoutdetail" render={(props) => <PayoutDetail auth={auth} {...props} />} />
              <Route path="/payoutdetailinstant" render={(props) => <PayoutDetailInstant auth={auth} {...props} />} />
              <Route path="/partner" render={(props) => <Partner auth={auth} {...props} />} />
              <Route path="/projects" render={(props) => <Projects auth={auth} {...props} />} />
              <Route path="/order" render={(props) => <PartnerHome auth={auth} {...props} />} />
              <Route path="/steppersignin" render={(props) => <StepSignInUp auth={auth} {...props} />} />
              <Route path="/steppersigninemail" render={(props) => <StepSignUpCheckEmail auth={auth} {...props} />} />
              <Route path="/steppercustomerauthorize" render={(props) => <StepperAuthorize auth={auth} {...props} />} />
              <Route path="/appentry" render={(props) => <MagicLinkHome auth={auth} {...props} />} />
              <Route path="/systemdown" render={(props) => <SystemDownAlert auth={auth} {...props} />} />
              <Route path="/ProfitabilityReport" render={(props) => <ProfitabilityReport auth={auth} {...props} />} />
              <Route path="/verify/:id" render={(props) => <Verify auth={auth} {...props} />} />
              <Route path="/oa2/:id" render={(props) => <OAuth2Redirect auth={auth} {...props} />} />
              <Route path="/plaidoa2" render={(props) => <PlaidOAuth2Redirect auth={auth} {...props} />} />
              <Route path="/oidcinit/:op/:rp" render={(props) => <OidcRedirect auth={auth} {...props} />} />
              <Route path="/oidc/:op" render={(props) => <OidcRedirect auth={auth} {...props} />} />
              <Route path="/subscriptionorderview" render={(props) => <SubscriptionOrderView orderId='' auth={auth} navopen={this.state.open} {...props} />} />
              <Route path="/vendorprogramform" render={(props) => <VendorProgramForm accountId='' formId='' auth={auth} {...props} />} />

              {/* prototyping for peer-to-peer SO */}
              <Route path="/subscriptionorderapprove" render={(props) => <SubscriptionOrderApprove auth={auth} {...props} />} />

            <Route path="/logout" render={() => {
                this.logout();
              }} />
              <Route path="/callback" render={(props) => {
                this.handleAuthentication(props);
                return <Callback {...props} />
              }} />
            <Route path="*" render={() => <Redirect to="/home" />} />
              {/*
              <Route render={(props) => <Home auth={auth} {...props} />} />
              */}
            </Switch>
          </main>
        </div>
      </Router>
    );
  }
}

export default withStyles(styleSheet)(MainRoute);
